import React from 'react';
import { CalendarIcon, BookOpenIcon, TargetIcon, UsersIcon, ZapIcon, DollarSignIcon, ChevronLeftIcon, ChevronRightIcon, BrainIcon, LightbulbIcon } from 'lucide-react';
export const Benefits = () => {
  const benefits = [{
    title: 'Kickoff in 48 hours',
    description: 'Start your project in 48 hours, skipping lengthy hiring processes.',
    icon: <CalendarIcon className="w-12 h-12 text-white" data-id="element-315" />,
    gradient: 'from-amber-400 to-orange-600'
  }, {
    title: 'AI-Driven Insights',
    description: 'Leverage our AI tools for rapid market analysis, persona creation and idea validation—decisions backed by data, not guesswork.',
    icon: <BrainIcon className="w-12 h-12 text-white" data-id="element-316" />,
    gradient: 'from-blue-600 to-green-400'
  }, {
    title: 'Rapid Prototyping',
    description: 'We create prototypes or MVPs within days to test hypotheses and gather feedback quickly.',
    icon: <LightbulbIcon className="w-12 h-12 text-white" data-id="element-317" />,
    gradient: 'from-orange-500 to-purple-700'
  }, {
    title: 'Integrated teammate',
    description: 'Your PM joins your Slack, JIRA, and GitHub, becoming a seamless part of your team and using AI assistants to keep everyone aligned.',
    icon: <UsersIcon className="w-12 h-12 text-white" data-id="element-318" />,
    gradient: 'from-pink-500 to-green-500'
  }, {
    title: 'Rapid execution',
    description: 'Reduce onboarding time by 75% with PMs who deliver value from day one.',
    icon: <ZapIcon className="w-12 h-12 text-white" data-id="element-319" />,
    gradient: 'from-orange-500 to-purple-700'
  }, {
    title: 'Cost-effective',
    description: 'Save up to 60% compared to a full-time hire while still getting expert AI and prototyping capabilities.',
    icon: <DollarSignIcon className="w-12 h-12 text-white" data-id="element-320" />,
    gradient: 'from-red-500 to-blue-600'
  }];
  return <section id="benefits" className="py-20 bg-purple-50 relative overflow-hidden" data-id="element-321">
      {/* Using CSS gradients instead of large background images */}
      <div className="absolute top-0 right-0 w-80 h-80 bg-gradient-to-br from-purple-100 to-purple-50 rounded-full opacity-40 -mr-40 -mt-40" data-id="element-322"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tl from-purple-100 to-purple-50 rounded-full opacity-30 -ml-48 -mb-48" data-id="element-323"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-324">
        <div className="text-center mb-16" data-id="element-325">
          <h2 className="text-3xl md:text-5xl font-bold mb-2 text-black max-w-4xl mx-auto leading-tight" data-id="element-326">
            Why high-growth teams choose ZERO TO TEN
          </h2>
        </div>
        <div className="relative max-w-6xl mx-auto" data-id="element-327">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-328">
            {benefits.map((benefit, index) => <div key={index} className={`rounded-3xl overflow-hidden bg-gradient-to-br ${benefit.gradient} p-8 shadow-lg transform transition-transform hover:scale-105`} data-id="element-329">
                <div className="flex justify-center items-center mb-6" data-id="element-330">
                  <div className="p-4 rounded-full bg-white bg-opacity-20 backdrop-blur-sm shadow-inner" data-id="element-331">
                    {benefit.icon}
                  </div>
                </div>
                <h3 className="text-xl font-bold mb-3 text-white text-center" data-id="element-332">
                  {benefit.title}
                </h3>
                <p className="text-white text-opacity-90 text-center" data-id="element-333">
                  {benefit.description}
                </p>
              </div>)}
          </div>
          <div className="flex justify-center mt-8 gap-4" data-id="element-334">
            <button className="p-3 rounded-full bg-white shadow-md hover:shadow-lg transition-shadow" data-id="element-335">
              <ChevronLeftIcon className="w-5 h-5 text-gray-600" data-id="element-336" />
            </button>
            <button className="p-3 rounded-full bg-white shadow-md hover:shadow-lg transition-shadow" data-id="element-337">
              <ChevronRightIcon className="w-5 h-5 text-gray-600" data-id="element-338" />
            </button>
          </div>
        </div>
      </div>
    </section>;
};